<button mat-icon-button class="dialog-close-btn" (click)="onNoClick()"><mat-icon>close</mat-icon></button>
<div class="chart-editor">
    <iframe src="assets/js/highchart-editor/editor.html"></iframe>
</div>

